import { buildReducer } from './buildReducer';

export default buildReducer({ fetchAction: 'ROTH_RETIREMENT_ACCOUNTS_FETCHED' });
